import Header from './components/Header';
import Carousel from './components/Carousel';

function App() {
  return (
    <div className="App">
      <Header />
      <Carousel />
    </div>
  );
}

export default App;
